import type { ReactNode } from 'react';
import React from 'react';

import * as styles from '../styles/Body.styles';

export interface BodyProps {
  children: ReactNode;
}

export const Body = ({ children }: BodyProps) => (
  <div css={styles.bodyWrapper}>
    <div>{children}</div>
  </div>
);
